"use strict";

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueArrElements = exports.stationMatchesUserInput = exports.sortStations = exports.parseSuggestions = exports.parseItems = exports.hasDuplicates = exports.getUnmatchedCityCodeObject = exports.getStationObjectFromCode = exports.getRecentSearches = exports.getRecentCodeData = exports.getProviderForCitySearch = exports.getP4AndCityCodeEmptyAndStationTypeA = exports.getMatchedCityCodeObject = exports.getIcon = exports.getDestinationProviderForCitySearch = exports.getDestinationAirportsObject = exports.getDestinationAirportsList = exports.getCityCodes = exports.formatStationObject = exports.formatStationDisplayName = exports.findDuplicateInStrOfArr = exports.filteredSuggestion = exports.filterPrioritizedData = exports.filterList = exports.fetchStationObject = exports.checkIfValidStation = exports.assignPriorityToOrphanCities = exports.addRecentSearchLabelIcon = exports.addNearestAirportLocationIcon = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _constant = require("../constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var sortStations = function sortStations(stationList, isFiltered) {
  if (!stationList) return;
  stationList.sort(function (a, b) {
    return b.Weightage - a.Weightage || (isFiltered ? a.Priority - b.Priority || a.StationName.localeCompare(b.StationName) : a.StationName.localeCompare(b.StationName));
  });
  return stationList;
};

exports.sortStations = sortStations;

var stationMatchesUserInput = function stationMatchesUserInput(obj, input) {
  if (!obj || !obj.StationName || !obj.StationCode) return false;
  var st = {
    StationName: obj.StationName.toLowerCase(),
    StationCode: obj.StationCode.toLowerCase(),
    PinYin: (obj.PinYin || '').toLowerCase(),
    AlternativeName: (obj.AlternativeName || '').toLowerCase(),
    AirportName: (obj.AirportName || '').toLowerCase(),
    CountryName: (obj.CountryName || '').toLowerCase(),
    CityName: (obj.CityName || '').toLowerCase(),
    CityCode: (obj.CityCode || '').toLowerCase(),
    Tag: (obj.Tag || '').toLowerCase()
  }; // eslint-disable-next-line default-case

  switch (true) {
    case st.CityName.startsWith(input):
      obj.Priority = 0;
      return true;

    case st.CityCode.startsWith(input):
      obj.Priority = 1;
      return true;

    case st.StationName.startsWith(input):
      obj.Priority = 2;
      return true;

    case st.StationCode.startsWith(input):
      obj.Priority = 3;
      return true;

    case st.Tag.includes(input):
      obj.Priority = 4;
      return true;

    case st.PinYin.startsWith(input):
      obj.Priority = 5;
      return true;

    case st.StationName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      obj.Priority = 6;
      return true;

    case st.AlternativeName.startsWith(input):
      obj.Priority = 7;
      return true;

    case st.AlternativeName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      obj.Priority = 8;
      return true;

    case st.AirportName.startsWith(input):
      obj.Priority = 9;
      return true;

    case st.AirportName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      obj.Priority = 10;
      return true;

    case st.CountryName.startsWith(input):
      obj.Priority = 11;
      return true;

    case st.CountryName.split(' ').some(function (val) {
      return val.startsWith(input);
    }):
      obj.Priority = 12;
      return true;
  }
};

exports.stationMatchesUserInput = stationMatchesUserInput;

var getIcon = function getIcon(stationType) {
  switch (stationType && stationType.toUpperCase()) {
    case _constant.STATION_TYPES.AIR_PORTS:
      return _constant.STATION_ICONS.AIR_PORTS_ICON;

    case _constant.STATION_TYPES.FERIES:
      return _constant.STATION_ICONS.FERIES_ICON;

    case _constant.STATION_TYPES.HOTEL_OR_BUSES:
      return _constant.STATION_ICONS.HOTEL_OR_BUSES_ICON;

    case _constant.STATION_TYPES.CITY:
      return _constant.STATION_ICONS.LOCATION_ON_ICON;

    default:
      return '';
  }
};

exports.getIcon = getIcon;

var addNearestAirportLocationIcon = function addNearestAirportLocationIcon(stationList) {
  var nearestAirports = [];

  if (stationList) {
    stationList.forEach(function (station) {
      var newObj = _objectSpread({}, station);

      newObj.iconName = _constant.STATION_ICONS.LOCATION_ON_ICON;
      nearestAirports.push(newObj);
    });
  }

  return nearestAirports;
};

exports.addNearestAirportLocationIcon = addNearestAirportLocationIcon;

var addRecentSearchLabelIcon = function addRecentSearchLabelIcon(stationList) {
  var recentSearchStations = [];

  if (stationList) {
    stationList.forEach(function (station) {
      if (station) {
        var newObj = _objectSpread({}, station);

        newObj.iconName = _constant.STATION_ICONS.RECENT_SEARCH_ICON;
        recentSearchStations.push(newObj);
      }
    });
  }

  return recentSearchStations;
};

exports.addRecentSearchLabelIcon = addRecentSearchLabelIcon;

var formatStationObject = function formatStationObject(station) {
  if (!station) {
    return;
  }

  return _objectSpread(_objectSpread({}, station), {}, {
    mainDisplayName: station.StationType && station.StationType === _constant.FILTER_TYPE.CITY_KEY ? "".concat(station.CityName) : "".concat(station.AirportName),
    iconName: station.StationType ? getIcon(station.StationType) : '',
    airportCode: station.StationCode,
    carrier: station.AAFlight === true ? 'AAI' : 'KIWI'
  });
};

exports.formatStationObject = formatStationObject;

var parseItems = function parseItems(items) {
  return items && items.map(function (suggestion) {
    return suggestion !== null && formatStationObject(suggestion);
  }).filter(function (_ref) {
    var iconName = _ref.iconName;
    return iconName !== '';
  });
};

exports.parseItems = parseItems;

var formatStationDisplayName = function formatStationDisplayName(station) {
  if (!station) {
    return;
  }

  return _objectSpread(_objectSpread({}, station), {}, {
    mainDisplayName: station.IsCity ? "".concat(station.CityName) : "".concat(station.AirportName)
  });
};

exports.formatStationDisplayName = formatStationDisplayName;

var parseSuggestions = function parseSuggestions(results) {
  if (results && results.length > 0) {
    var formattedResults = parseItems(results);
    return formattedResults;
  }

  return [];
};

exports.parseSuggestions = parseSuggestions;

var listOfObjsByCityCode = function listOfObjsByCityCode(listOfObjs, cityCode) {
  if (listOfObjs && listOfObjs.length) {
    var arr = listOfObjs.filter(function (ele) {
      return ele.CityCode === cityCode;
    });
    return arr;
  }

  return null;
};

var getProviderForCitySearch = function getProviderForCitySearch(listOfObjs, provider) {
  if (listOfObjs && listOfObjs.length) {
    var bool = listOfObjs.some(function (ele) {
      return ele.Provider === provider;
    }); // if one of the providers inside the stations of a city is AAB then provider value is automatically AAB

    if (bool) return _constant.PROVIDERS.AAB;
    return _constant.PROVIDERS.OTA;
  }

  return _constant.PROVIDERS.AAB; // if objects not found, the provider is AAB
};

exports.getProviderForCitySearch = getProviderForCitySearch;

var getDestinationProviderForCitySearch = function getDestinationProviderForCitySearch(destinationCode, destinationData, data) {
  var provider = _constant.PROVIDERS.AAB;

  if (destinationData && destinationData.length) {
    var objectFromKeys = Object.values(destinationData[0]);
    var arrOfObjsByCityCode = listOfObjsByCityCode(objectFromKeys, destinationCode);

    if (arrOfObjsByCityCode && arrOfObjsByCityCode.length > 0) {
      provider = getProviderForCitySearch(arrOfObjsByCityCode, _constant.PROVIDERS.AAB);
    }

    data.AAFlight = provider === _constant.PROVIDERS.AAB;
    data.Provider = provider;
    return data;
  }

  return null;
};

exports.getDestinationProviderForCitySearch = getDestinationProviderForCitySearch;

var getDestinationAirportsObject = function getDestinationAirportsObject(allStationsList, destinationObject) {
  var destinationList = [];

  if (allStationsList && (0, _lodash.isArray)(allStationsList) && allStationsList.length > 0 && destinationObject) {
    destinationList = allStationsList.filter(function (data) {
      var key = data.StationType === _constant.FILTER_TYPE.CITY_KEY ? data.CityCode : data.StationCode; // fetch Provider value for city code based on their stations

      if (data.StationType === _constant.FILTER_TYPE.CITY_KEY) {
        return getDestinationProviderForCitySearch(key, [destinationObject], data);
      } // fetch Provider value for station code (existing/default logic)


      if (Object.prototype.hasOwnProperty.call(destinationObject, key)) {
        var providerValue = destinationObject[key].Provider; // eslint-disable-next-line no-param-reassign

        data.AAFlight = destinationObject[key].AAFlight; // if provider value is AAB, set provider as AAB otherwise OTA

        data.Provider = providerValue === _constant.PROVIDERS.AAB ? providerValue : _constant.PROVIDERS.OTA;
        return data;
      }

      return null;
    });
  }

  return destinationList;
};

exports.getDestinationAirportsObject = getDestinationAirportsObject;

var getDestinationAirportsList = function getDestinationAirportsList(data) {
  var destinationObject = {};

  if (data) {
    Object.keys(data).map(function (key) {
      Object.keys(data[key]).map(function (item) {
        destinationObject[item] = {
          AAFlight: data[key][item].AAFlight,
          Provider: data[key][item].Provider,
          CityCode: data[key][item].CityCode
        };
        return null;
      });
      return null;
    });
  }

  return destinationObject;
}; // returns the data of the selected city/station from recent searches


exports.getDestinationAirportsList = getDestinationAirportsList;

var getRecentCodeData = function getRecentCodeData(value, list, identifierKey, routeKey) {
  var stationData = value.split('/');
  var data = [];

  if (stationData.length >= 2 && list) {
    var _stationData = (0, _slicedToArray2.default)(stationData, 2),
        code = _stationData[0],
        type = _stationData[1];

    data = type === 'true' ? list.filter(function (val) {
      return val.route[identifierKey] === true;
    }) : null;

    if (code && data) {
      for (var i = 0; i < list.length; i++) {
        data = list.filter(function (ele) {
          return ele.route[routeKey] === code;
        });
        return data[i].route.destinationData;
      }
    }
  }

  return data;
}; // filter city if station type is C otherwise return all other data not equal to city (such as station & ferry)


exports.getRecentCodeData = getRecentCodeData;

var filterList = function filterList(sTypeFromList, sType) {
  if (sType === _constant.FILTER_TYPE.CITY_KEY) {
    return sTypeFromList === sType;
  }

  return sTypeFromList !== _constant.FILTER_TYPE.CITY_KEY;
};

exports.filterList = filterList;

var getStationObjectFromCode = function getStationObjectFromCode(stationCode) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isFromNearest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!data) return null;
  var sCode = stationCode;
  var sType = _constant.FILTER_TYPE.STATION_KEY;
  var filter = _constant.FILTER_TYPE.STATION_CODE;
  var stationData = stationCode.split('/');

  if (stationData.length >= 2) {
    var _stationData2 = (0, _slicedToArray2.default)(stationData, 2),
        code = _stationData2[0],
        type = _stationData2[1];

    filter = type === 'true' ? _constant.FILTER_TYPE.CITY_CODE : _constant.FILTER_TYPE.STATION_CODE;
    sType = type === 'true' ? _constant.FILTER_TYPE.CITY_KEY : _constant.FILTER_TYPE.STATION_KEY;
    sCode = code;
  }

  if (isFromNearest) {
    var nearestCityWithSameName = data.filter(function (item) {
      return item[filter].toLowerCase() === sCode.toLowerCase() && (item === null || item === void 0 ? void 0 : item.StationType) === _constant.FILTER_TYPE.CITY_KEY;
    });

    if (nearestCityWithSameName.length > 0 && nearestCityWithSameName[0]) {
      return nearestCityWithSameName[0] || null;
    }

    var stationValue = data.filter(function (item) {
      return item[filter].toLowerCase() === sCode.toLowerCase() && filterList(item.StationType, sType);
    });
    var filteredStationValue = stationValue.length > 0 ? stationValue[0] : null;
    var nearestCityWithDifferentName = data.filter(function (item) {
      var _stationValue$;

      return item[filter].toLowerCase() === ((_stationValue$ = stationValue[0]) === null || _stationValue$ === void 0 ? void 0 : _stationValue$.CityCode.toLowerCase()) && (item === null || item === void 0 ? void 0 : item.StationType) === _constant.FILTER_TYPE.CITY_KEY;
    });
    var filteredNearestCityWithDifferentName = nearestCityWithDifferentName.length > 0 ? nearestCityWithDifferentName[0] : null;
    return filteredNearestCityWithDifferentName || filteredStationValue || null;
  }

  for (var i = 0; i < data.length; i++) {
    if (data[i][filter].toLowerCase() === sCode.toLowerCase() && filterList(data[i].StationType, sType)) {
      return data[i];
    }
  }

  return null;
};

exports.getStationObjectFromCode = getStationObjectFromCode;

var findDuplicateInStrOfArr = function findDuplicateInStrOfArr(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) !== index;
  });
};

exports.findDuplicateInStrOfArr = findDuplicateInStrOfArr;

var getRecentSearches = function getRecentSearches() {
  var searches = localStorage.getItem('recentSearches');

  if (searches != null) {
    searches = JSON.parse(decodeURIComponent(searches));
  }

  return searches;
};

exports.getRecentSearches = getRecentSearches;

var checkIfValidStation = function checkIfValidStation(obj, input) {
  if (!obj || !obj.StationName || !obj.StationCode) return false;
  var st = {
    StationCode: obj.StationCode.toLowerCase()
  };
  return st.StationCode === input;
};

exports.checkIfValidStation = checkIfValidStation;

var fetchStationObject = function fetchStationObject(input, stations) {
  if (stations && input) {
    return stations.filter(function (station) {
      var inputLoweCase = input.toLowerCase();
      if (checkIfValidStation(station, inputLoweCase)) return station;
      return null;
    });
  }

  return null;
};

exports.fetchStationObject = fetchStationObject;

var assignPriorityToOrphanCities = function assignPriorityToOrphanCities(unMatchedCityCodeArr, searchKey) {
  var data = [];

  if (unMatchedCityCodeArr) {
    for (var i = 0; i < unMatchedCityCodeArr.length; i++) {
      var stationObj = JSON.parse(JSON.stringify(unMatchedCityCodeArr[i]));
      stationObj.CityCode = '';
      stationObj.CityName = '';

      if (stationMatchesUserInput(stationObj, (searchKey || '').toLowerCase())) {
        stationObj.CityName = unMatchedCityCodeArr[i].CityName;
        stationObj.CityCode = unMatchedCityCodeArr[i].CityCode;
        data.push(stationObj);
      }
    }
  }

  return data;
};

exports.assignPriorityToOrphanCities = assignPriorityToOrphanCities;

var hasDuplicates = function hasDuplicates(array) {
  if (!array) {
    return;
  }

  return new Set(array).size !== array.length;
};

exports.hasDuplicates = hasDuplicates;

var getCityCodes = function getCityCodes(arr) {
  var codes = [];

  if (arr) {
    for (var i = 0; i < arr.length; i++) {
      codes.push(arr[i].CityCode);
    }
  }

  return codes;
};

exports.getCityCodes = getCityCodes;

var getMatchedCityCodeObject = function getMatchedCityCodeObject(list, cityCodesArr) {
  var data = [];

  if (list && cityCodesArr) {
    var _loop = function _loop(i) {
      data = list.filter(function (ele) {
        return ele.CityCode !== cityCodesArr[i];
      });
    };

    for (var i = 0; i < cityCodesArr.length; i++) {
      _loop(i);
    }
  }

  return data;
};

exports.getMatchedCityCodeObject = getMatchedCityCodeObject;

var getUnmatchedCityCodeObject = function getUnmatchedCityCodeObject(list, cityCodesArr) {
  var data = [];

  if (list && cityCodesArr) {
    var _loop2 = function _loop2(i) {
      data = list.filter(function (ele) {
        return ele.CityCode === cityCodesArr[i];
      });
    };

    for (var i = 0; i < cityCodesArr.length; i++) {
      _loop2(i);
    }
  }

  return data;
};

exports.getUnmatchedCityCodeObject = getUnmatchedCityCodeObject;

var uniqueArrElements = function uniqueArrElements(arr) {
  if (!arr) {
    return;
  }

  return arr.filter(function (v, _, a) {
    return a.indexOf(v) === a.lastIndexOf(v);
  });
};

exports.uniqueArrElements = uniqueArrElements;

var filterPrioritizedData = function filterPrioritizedData(filteredSuggestions) {
  var priorityArray = [];

  if (filteredSuggestions) {
    for (var i = 0; i < filteredSuggestions.length; i++) {
      var filteredSuggestionsObject = filteredSuggestions[i];

      if ((filteredSuggestionsObject.Priority <= 1 || filteredSuggestionsObject.Priority === 4) && filteredSuggestionsObject.CityCode !== '') {
        priorityArray.push(filteredSuggestionsObject);
      }
    }
  }

  return priorityArray;
};
/**
 * Below code fetches only those object that has
 * priority 4 , City Code is empty and StationType is A
 */


exports.filterPrioritizedData = filterPrioritizedData;

var getP4AndCityCodeEmptyAndStationTypeA = function getP4AndCityCodeEmptyAndStationTypeA(filteredSuggestions) {
  if ((filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length) > 0) {
    var p4AndCityCodeEmptyAndStationTypeA = [];

    for (var i = 0; i < (filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length); i++) {
      var _filteredSuggestionsO;

      var filteredSuggestionsObject = filteredSuggestions[i];

      if ((filteredSuggestionsObject === null || filteredSuggestionsObject === void 0 ? void 0 : filteredSuggestionsObject.Priority) === _constant.TAG_PRIORITY && (filteredSuggestionsObject === null || filteredSuggestionsObject === void 0 ? void 0 : filteredSuggestionsObject.CityCode) === '' && (filteredSuggestionsObject === null || filteredSuggestionsObject === void 0 || (_filteredSuggestionsO = filteredSuggestionsObject.StationType) === null || _filteredSuggestionsO === void 0 ? void 0 : _filteredSuggestionsO.toUpperCase()) === _constant.STATION_TYPES.AIR_PORTS) {
        // eslint-disable-next-line no-unused-expressions
        p4AndCityCodeEmptyAndStationTypeA === null || p4AndCityCodeEmptyAndStationTypeA === void 0 || p4AndCityCodeEmptyAndStationTypeA.push(filteredSuggestionsObject);
      }
    }

    return p4AndCityCodeEmptyAndStationTypeA;
  }

  return [];
};

exports.getP4AndCityCodeEmptyAndStationTypeA = getP4AndCityCodeEmptyAndStationTypeA;

var filteredSuggestion = function filteredSuggestion(input, res) {
  var filteredSuggestions = [];

  if (res && Array.isArray(res)) {
    var filteredStations = res.filter(function (val) {
      return val.StationType !== _constant.FILTER_TYPE.CITY_KEY;
    });
    var filteredCities = res.filter(function (val) {
      return val.StationType === _constant.FILTER_TYPE.CITY_KEY;
    });

    for (var i = 0; i < filteredStations.length; i++) {
      var inputLoweCase = input ? input.toLowerCase() : '';
      var stationObj = filteredStations[i];

      if (stationMatchesUserInput(stationObj, (inputLoweCase || '').toLowerCase())) {
        filteredSuggestions.push(stationObj);
      }
    } // Filter the suggestions to get all stations with same CityCode


    filteredSuggestions.forEach(function (fs) {
      var inputLoweCase = input ? input.toLowerCase() : '';
      var newPriority; // Check if the input is Station Code then force the priority to 4

      if (fs.StationCode.toLowerCase() === inputLoweCase && fs.CityCode !== fs.StationCode) {
        newPriority = 4;
      } else {
        newPriority = fs.Priority;
      }

      var filteredCitySuggestions = filteredStations.filter(function (results) {
        return results.CityCode === fs.CityCode && fs.StationCode !== results.StationCode && results.StationType === _constant.FILTER_TYPE.STATION_KEY && results.CityCode !== '';
      }).map(function (filtered) {
        filtered.Priority = newPriority;
        return filtered;
      });

      if (filteredCitySuggestions.length > 0) {
        fs.Priority = newPriority;
      } // Merge the filtered stations and removed the duplicates


      filteredSuggestions = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(filteredSuggestions), (0, _toConsumableArray2.default)(filteredCitySuggestions))));
    });
    var priorityArray = filterPrioritizedData(filteredSuggestions); // Group By City Name

    var groupByCityResults = [];

    if (priorityArray) {
      groupByCityResults = priorityArray.reduce(function (r, a) {
        r[a.CityCode] = r[a.CityCode] || [];
        r[a.CityCode].push(a);
        return r;
      }, Object.create(null));
    }

    var index = 0;
    var groupedCities = [];

    if (groupByCityResults) {
      var _loop3 = function _loop3(key) {
        var _dest$;

        var cityCode = key;
        var cityData = Object.values(groupByCityResults)[index][0];
        var dest = filteredCities.filter(function (val) {
          return val.CityCode === key;
        });
        var cityObj = {
          CityName: cityData.CityName,
          CityCode: cityCode,
          CountryName: cityData.CountryName,
          CountryCode: cityData.CountryCode,
          Priority: cityData.Priority,
          StationName: cityData.CityName,
          StationCode: cityCode,
          IsCity: true,
          Stations: [],
          iconName: _constant.STATION_ICONS.LOCATION_ON_ICON,
          Dest: dest && dest.length > 0 ? dest[0].Dest : '',
          StationType: _constant.FILTER_TYPE.CITY_KEY,
          Weightage: (_dest$ = dest[0]) === null || _dest$ === void 0 ? void 0 : _dest$.Weightage
        };
        var sortedStation = sortStations(Object.values(groupByCityResults)[index], true);
        cityObj.Stations = sortedStation;
        groupedCities.push(cityObj);
        index += 1;
      }; // eslint-disable-next-line no-restricted-syntax, guard-for-in


      for (var key in groupByCityResults) {
        _loop3(key);
      }
    }

    var priorityGreaterThanOne = [];

    for (var _i = 0; _i < filteredSuggestions.length; _i++) {
      var filteredSuggestionsObject = filteredSuggestions[_i];

      if (filteredSuggestionsObject.Priority > 1 && filteredSuggestionsObject.Priority !== 4) {
        priorityGreaterThanOne.push(filteredSuggestionsObject);
      }
    }
    /**
     * getP4AndCityCodeEmptyAndStationTypeA function fetches
     * only those object that has priority 4 , City Code is
     * empty and StationType is A
     */


    var p4AndCityCodeEmptyAndStationTypeA = getP4AndCityCodeEmptyAndStationTypeA(filteredSuggestions) || []; // combined results

    var unsortedCityLvlGroupedStations = groupedCities.concat(priorityGreaterThanOne, p4AndCityCodeEmptyAndStationTypeA);
    filteredSuggestions = sortStations(unsortedCityLvlGroupedStations, true);
  }

  return filteredSuggestions;
};

exports.filteredSuggestion = filteredSuggestion;